export default {
        srcSet: __webpack_public_path__ + "static/media/zigzag-bottom.635d4a93.png"+" 1812w",
        images: [{path: __webpack_public_path__ + "static/media/zigzag-bottom.635d4a93.png",width: 1812,height: 56}],
        src: __webpack_public_path__ + "static/media/zigzag-bottom.635d4a93.png",
        toString: function(){return __webpack_public_path__ + "static/media/zigzag-bottom.635d4a93.png"},
        placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAABCAMAAACbgxyhAAAACVBMVEVVk5RXk5NWlJXUj13WAAAAA3RSTlNZT0nh+nsfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVR4nGNgYmRgZGRgACEwC8RhAnPAFFwYAAIrABlDUT0WAAAAAElFTkSuQmCC",
        width: 1812,
        height: 56
      }